import { headerStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaHeader";
import { css } from "styled-components";

Object.assign(headerStyles, {
    ...headerStyles,
    buttonsGridItem: {
        css: css`
            display: none;
        `,
    },
});
